import { render, staticRenderFns } from "./FaturamentoSemanal.vue?vue&type=template&id=afcfd8ea&scoped=true&"
import script from "./FaturamentoSemanal.vue?vue&type=script&lang=js&"
export * from "./FaturamentoSemanal.vue?vue&type=script&lang=js&"
import style0 from "./FaturamentoSemanal.vue?vue&type=style&index=0&id=afcfd8ea&scoped=true&lang=css&"
import style1 from "./FaturamentoSemanal.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afcfd8ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VContainer,VIcon,VRow,VSheet})
